// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error_errorPage__AbrZ7"};